export const sysList = {
  pointGroupItem: {
    flexWrap: 'nowrap',
    ml: '16px',
    fontSize: '0.8rem',
    mb: 1,
    w: '100%',
  },
  pointItemName: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    overflow: 'hidden',
    maxWidth: '80%',
  },
  pointItemValue: {
    whiteSpace: 'nowrap',
    display: 'inline-block',
    overflow: 'hidden',
    marginLeft: '16px',
    minWidth: '20%',
    textAlign: 'right',
  },
};
